/*
 * Lib Module Debug
 *
 * Frontend debugging and console logging
 */

Lib.Debug = (function() {
    var self = {};

    self.logAllowed = false;

    var prefix = '🤖: ';

    /**
     * isDebug wrapper for console.log
     * @param msg
     * @param opts
     */
    self.log = function(msg, opts) {
        if (self.logAllowed) {
            if (opts) {
                if (typeof msg === 'string') {
                    console.log(prefix + msg, opts);
                } else {
                    console.log(msg, opts);
                }
            } else {
                if (typeof msg === 'string') {
                    console.log(prefix + msg);
                } else {
                    console.log(msg);
                }
            }
        }
    };

    /**
     * isDebug wrapper for console.warn
     * @param msg
     * @param opts
     */
    self.warn = function(msg, opts) {
        if (self.logAllowed) {
            if (opts) {
                if (typeof msg === 'string') {
                    console.warn(prefix + msg, opts);
                } else {
                    console.warn(msg, opts);
                }
            } else {
                if (typeof msg === 'string') {
                    console.warn(prefix + msg);
                } else {
                    console.warn(msg);
                }
            }
        }
    };

    /**
     * isDebug wrapper for console.error
     * @param msg
     * @param opts
     */
    self.error = function(msg, opts) {
        if (self.logAllowed) {
            if (opts) {
                if (typeof msg === 'string') {
                    console.error(prefix + msg, opts);
                } else {
                    console.error(msg, opts);
                }
            } else {
                if (typeof msg === 'string') {
                    console.error(prefix + msg);
                } else {
                    console.error(msg);
                }
            }
        }
    };

    /**
     * isDebug wrapper for console.info
     * @param msg
     * @param opts
     */
    self.info = function(msg, opts) {
        if (self.logAllowed) {
            if (opts) {
                if (typeof msg === 'string') {
                    console.info(prefix + msg, opts);
                } else {
                    console.info(msg, opts);
                }
            } else {
                if (typeof msg === 'string') {
                    console.info(prefix + msg);
                } else {
                    console.info(msg);
                }
            }
        }
    };

    /**
     * Check if we are in dev
     */
    self.isDevelopment = function() {
        return Lib.Util.getOption('development');
    };

    /**
     * Check if we are in debug
     */
    self.isDebug = function() {
        return Lib.Util.getOption('debug');
    };

    /**
     * Check if we are Hetwonen devuser
     */
    self.isDTU = function() {
        return Lib.Util.getOption('data.dtu');
    };


    /**
     *
     */
    self.allowMessages = function() {
        self.logAllowed = self.isDebug();
    };

    /**
     *
     */
    self.blockMessages = function() {
        self.logAllowed = false;
    };


    $(Lib).on('before.document.ready', function() {
        self.logAllowed = self.isDebug();
    });

    return self;
})();
